<template>
  <svg
    class="icon-search"
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.8304 12.2144C9.75303 13.096 8.37579 13.625 6.875 13.625C3.42322 13.625 0.625 10.8268 0.625 7.375C0.625 3.92322 3.42322 1.125 6.875 1.125C10.3268 1.125 13.125 3.92322 13.125 7.375C13.125 8.8758 12.596 10.2531 11.7143 11.3305L14.1919 13.8081C14.436 14.0521 14.436 14.4479 14.1919 14.6919C13.9478 14.936 13.5521 14.936 13.308 14.6919L10.8304 12.2144ZM11.875 7.375C11.875 10.1364 9.63642 12.375 6.875 12.375C4.11358 12.375 1.875 10.1364 1.875 7.375C1.875 4.61358 4.11358 2.375 6.875 2.375C9.63642 2.375 11.875 4.61358 11.875 7.375Z"
      fill="#222049"
    />
  </svg>
</template>

<script>
export default {
  name: "IconSearch"
};
</script>

<style></style>
